export default __webpack_public_path__ + "static/media/splash-1-min-2.d55a4c23.png";